<template>
    <div class="solicitud">
        <h2 class="text-center" v-text="campos.titulo"></h2>

        <form action="">
            <button type="button" class="d-none btn btn-primary text-white"  @click.prevent="test_referer()">Test referer</button>

            <transition-group name="fieldset-transition">
            </transition-group>

            <fieldset v-if="modo==='formulario'" key="formulario">
                <div style="display:none;">
                    <a href="#" @click.prevent="cambiar_pack('pack1')" :class="{'btn-pack': true, activo:campos.pack=='pack1'}">PACK 1</a>
                    <a href="#" @click.prevent="cambiar_pack('pack2')" :class="{'btn-pack': true, activo:campos.pack=='pack2'}">PACK 3</a>
                    <a href="#" @click.prevent="cambiar_pack('pack3')" :class="{'btn-pack': true, activo:campos.pack=='pack3'}">PACK 5</a>
                </div>
                
                <h4 class="pack-seleccionado">Seleccionaste el {{campos.pack}} con acceso a {{campos.sistema}}</h4>
                <h6>Por favor, completá los siguientes datos. Los marcados con (*) son obligatorios.</h6>

                <div v-if="debe_indicar_cantidad && campos.tipo=='software'">
                    <label for="cantidad">Cantidad de Licencias (cantidad de packs)</label>
                    <div class="row-corta">
                        <input name="cantidad" id="cantidad" type="number" min="1" max="50" v-model="campos.cantidad" @input="rango_cantidad">
                    </div>
                </div>

                <div v-if="campos.sistema == 'Discovery Easy Soft' && parametros.pack == 'Pack 1' && campos.tipo=='software'" >
                    <input type="checkbox" name="fiscal" id="fiscal" v-model="campos.fiscal" /> 
                    <label for="fiscal">Fiscal</label>
                </div>

                
                <div v-if="parametros.pack == 'Pack 5'">
                    <div>
                        <input type="checkbox" v-model="campos.quiere_adicionales" @click="campos.adicionales=''"> 
                        <span class="adicionales">Quiero agregar {{campos.adicionales_tipo}} a los incluidos en el Pack</span></div>
                    <div>
                        <!-- <label>Cantidad de {{campos.adicionales_tipo}}</label> -->
                        <div class="row-corta">
                            <input name="adicionales" id="adicionales" maxlength="2" type="number" min="1" max="15" placeholder=""
                                v-model="campos.adicionales" v-if="campos.quiere_adicionales"
                                :class="{desactivado: !campos.quiere_adicionales, activado:campos.quiere_adicionales}" >
                        </div>
                    </div>
                </div>

                <br>

                <h4>Datos de facturación</h4>
                <div>
                    <label for="razon_social">Titular (Razón Social / Apellido y Nombre) (*)</label>
                    <input name="razon_social" id="razon_social" maxlength="80" type="text" required v-model="campos.razon_social">
                </div>

                <div>
                    <label for="documento">Tipo de Documento</label>
                    <select name="documento" id="documento" v-model="campos.tipo_documento">
                        <option value="dni">DNI</option>
                        <option value="cuit">CUIT</option>
                    </select>
                    <label for="cuit">Número {{campos.tipo_documento.toUpperCase()}} (*)</label>
                    <input name="cuit" maxlength="100" type="text" required v-model="campos.cuit">
                </div>

                <div>
                    <label for="domicilio">Domicilio Legal - Calle, Nro, Localidad y Provincia (*)</label>
                    <input name="domicilio" id="domicilio" maxlength="80" type="text" required v-model="campos.domicilio">
                </div>

                <div style="display: none;">
                    <label for="iibb">N° Ingresos Brutos</label>
                    <input name="iibb" id="iibb" maxlength="100" type="text" v-model="campos.iibb">
                </div>


                
                <h4>Distribuidor</h4>
                <div>
                    <select name="distribuidor" id="distribuidor" v-model="campos.distribuidor.email" required @change="cambiar_distri" >
                        <option value="" disabled selected>Seleccionar...</option>
                        <option v-for="distri in distribuidores" :value="distri.email" :key="distri.distribuidor">{{distri.distribuidor}}</option>
                    </select>                    
                </div>


                <h4>Datos del solicitante</h4>
                <div>
                    <label for="nombre">Nombre (*)</label>
                    <input name="nombre" id="nombre" maxlength="80" type="text" required v-model="campos.nombre">
                </div>

                <div>
                    <label for="apellido">Apellido (*)</label>
                    <input name="apellido" id="apellido" maxlength="80" type="text" required v-model="campos.apellido">
                </div>

                <div>
                    <label for="mail">Email (*)</label>
                    <input name="mail" id="mail" maxlength="100" type="email" required v-model="campos.email">
                </div>

                <div>
                    <label for="telefono">Teléfono (*) (Ej: 011 4444-1111)</label>
                    <input name="telefono" id="telefono" maxlength="30" type="tel" required v-model="campos.telefono">
                </div>

                <div>
                    <label for="dni">DNI (*)</label>
                    <input name="dni" id="dni" maxlength="30" type="text" required v-model="campos.dni">
                </div>

                <div>
                    <label for="cargo">Cargo (*)</label>
                    <input name="cargo" id="cargo" maxlength="50" type="text" required v-model="campos.cargo">
                </div>

                <p>
                    <button type="button" class="boton solicitud-scroll" @click.prevent="procesar_form()" :disabled="!habilitado">
                        Siguiente <i class="fas fa-spinner" v-if="!habilitado" ></i>
                    </button>
                </p>
                
            </fieldset>            


            <fieldset v-if="modo=='contrato'" key="contrato">
                <p>A continuación lea detenidamente los detalles de la Solicitud para conocer sus alcances, luego acepte las Condiciones y presione "Aceptar" para continuar.</p>

                <!-- El siguiente contenido se reemplaza con lo que devuelve via api.php -->
                <div id="contrato" v-html="contrato"></div>

                <div v-if="tiene_versiones_anteriores">
                    <p>El pack que está solicitando corresponde a la versión <strong>{{version_vigente}}</strong>.
                    Hemos detectado que Ud. tiene instalado un Dispositivo de Control de Licencia (DCL) con una versión anterior.
                    Los DCL's de versiones anteriores no son compatibles con el pack, por lo que recomendamos que los actualice.
                    Si no los actualiza, puede seguir utilizándolos en su versión en una instalación independiente a la del pack.
                    </p>
                </div>

                <p><input name="acepta_contrato" id="acepta_contrato" type="checkbox" v-model="acepta_contrato">
                    <label for="acepta_contrato">{{acepta_label}}</label>
                </p>

                <div v-if="acepta_contrato">
                    <button type="button" class="boton" :disabled="!habilitado" @click="enviar_emails()">
                        Aceptar <i class="fas fa-spinner" v-if="!habilitado" ></i>
                    </button>
                </div>

                <BtnVolver @click="home" />
            </fieldset>


            <fieldset v-if="modo=='gracias'" key="gracias">
                <p>Gracias, hemos recibido su Solicitud para ({{campos.cantidad}}) {{parametros.sistema}} {{parametros.pack}}.<br>
                    Nuestro Distribuidor se pondrá en contacto con Ud. a la brevedad.</p>
                <p>Le agradecemos que haya confiado en una solución BAS para su empresa.</p>
                <p>Buenos Aires Software.</p>

               
                <BtnVolver @click="home" v-if="parametros.debug" />
            </fieldset>
            
            

            <div class="resultado" :class="this.resultado_modo" v-if="resultado">
                {{resultado}}
            </div>

        </form>

    </div>
</template>



<script>
    // Components
    import BtnVolver from '@/components/BtnVolver.vue';

    // Dependencies
    import jQuery from 'jquery';
    import alertify from 'alertifyjs';    
    import {log, server} from '../helpers/index.js';
    import 'alertifyjs/build/css/alertify.min.css';
    import 'alertifyjs/build/css/themes/default.min.css';

    export default {
        props: {
            parametros: Object
        },

        components: {
            BtnVolver
        },

        data() {
            return {
                modo: 'formulario',
                habilitado: true,
                resultado: null,
                resultado_modo: null,
                acepta_contrato: false,
                acepta_label: null,
                version_vigente: null,
                formas_pago: { PMC: 'Pagomiscuentas', AUT: 'Débito automático Tarjeta de Crédito' },
                contrato: null, // se carga dinamicamente,
                distribuidores: [],
                campos: {
                    grupo: 'distribuidores',
                    tipo: this.parametros.tipo_licenciamiento,
                    titulo: null, // depende del tipo,
                    sistema: this.parametros.sistema,
                    rubro: this.parametros.rubro,
                    idsistema: this.parametros.idsistema,
                    pack: this.parametros.pack,
                    cantidad: 1,
                    fiscal: false, // solo para DVY en PC (no en la nube)
                    quiere_adicionales: false, // exclusivo PACK5 
                    adicionales: "", // (int) cantidad
                    adicionales_tipo: "", //software => Accesos, saas => Usuarios
                    nombre: "",
                    apellido: "",
                    email: "",
                    telefono: "",
                    dni: "",
                    cargo: "",
                    razon_social: "",
                    tipo_documento: 'cuit',
                    cuit: "",
                    domicilio: "",
                    iibb: "",
                    distribuidor: {
                        distribuidor: '',
                        email: ''
                    },
                    es_cliente: null,
                    forma_pago: null,
                    forma_pago_cod: null,
                    tarjeta: {
                        titular: null,
                        tarjeta: null,
                        numero: null,
                        vto_mes: new Date().getMonth() + 1,
                        vto_anio: new Date().getFullYear()
                    },
                    versiones_instaladas: null, // es la versión del que tiene un cliente 
                    codcli: null,
                    tiene_producto: false,
                    tiene_sar: false
                }
            }
        },


        computed: {
            nombre_completo() {
                return this.campos.nombre + ' ' + this.campos.apellido;
            },
            debe_indicar_cantidad() {
                // En Pack 1 puede indicar más de 1 cantidad 
                return (this.campos.pack === 'Pack 1');                
            },
            tiene_versiones_anteriores() {
                let r = false;
                for (i in this.campos.versiones_instaladas) {
                    v = this.campos.versiones_instaladas[i];
                    if (v != this.version_vigente) {
                        r = true;
                        break;
                    }
                }
                return r;
            },

        },


        methods: {

            procesar_form(ev) {
                // se dispara en el fieldset formulario
                this.resetear_resultado();
                let validar = this.validar();
                if (validar == null) {
                    this.cambiar_modo('contrato');
                } else {
                    this.informar_error(validar);
                }
            },

            cambiar_modo(m) {
                this.resetear_resultado();
                this.modo = m;
                if (this.modo == 'contrato') {
                    this.completar_contrato();
                }                
                jQuery('body,html').animate({
                    scrollTop: jQuery("#app").offset().top
                }, 800);
                // document.getElementById("app").scrollIntoView({
                //     behavior: 'smooth'
                // });
                return false;
            },

            cambiar_pack(p) {
                this.campos.pack = p;
            },

            completar_contrato() {
                let self = this;
                this.contrato = 'Un momento por favor...';
                let data = {
                    action: 'render_contrato',
                    datos: self.campos,
                    // _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };

                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data
                })
                .done(function (msg) {
                    self.contrato = (msg);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    log(jqXHR, errorThrown);
                    self.resultado = errorThrown + " " + textStatus;
                })
                .always(function () {
                });
            },

            cargar_distribuidores() {
                let self = this;
                let data = {
                    action: 'listar_distribuidores',
                    datos: self.campos,
                    // _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };

                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data
                })
                .done(function (data) {
                    self.distribuidores = JSON.parse(data);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    log(jqXHR, errorThrown);
                    self.resultado = errorThrown + " " + textStatus;
                })
                .always(function () {
                });
            },

            cambiar_distri(event){
                let key = event.target.value; 
                let text = this.distribuidores[event.target.options.selectedIndex-1].distribuidor
                this.campos.distribuidor = {
                    email: key,
                    distribuidor: text
                }
            },

            enviar_emails() {
                this.habilitado = false;
                this.resetear_resultado();
                let self = this;
                let data = {
                    action: 'mail_before_submit_licencia',
                    datos: self.campos,
                    // _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };
                
                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data
                })
                .done(function (msg) {
                    if (self.parametros.debug){
                        log(msg);
                    }
                    self.finalizar();
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    log(jqXHR, errorThrown);
                    self.resultado = errorThrown + " " + textStatus;
                })
                .always(function () {
                    self.habilitado = true;
                });
            },

            finalizar() {
                this.habilitado = true;
                this.cambiar_modo('gracias');
            },

            validar() {
                let respuesta = null;
                
                if (this.campos.es_cliente && this.campos.codcli == null) {
                    respuesta = "Completar el Código de cliente"
                }
                if (this.campos.distribuidor.distribuidor == "") {
                    respuesta = "Seleccionar el distribuidor"
                }
                if (this.campos.nombre.trim() == "") {
                    respuesta = "Completar el Nombre"
                }
                if (this.campos.apellido.trim() == "") {
                    respuesta = "Completar el Apellido"
                }
                if (this.campos.email.trim() == "") {
                    respuesta = "Completar el Email"
                }
                if (this.campos.telefono.trim() == "") {
                    respuesta = "Completar el Teléfono"
                }
                if (this.campos.dni.trim() == "") {
                    respuesta = "Completar el DNI"
                }
                if (this.campos.cargo.trim() == "") {
                    respuesta = "Completar el Cargo"
                }
                if (this.campos.razon_social.trim() == "") {
                    respuesta = "Completar el Titular/Razón Social"
                }
                if (this.campos.cuit.trim() == "") {
                    respuesta = "Completar el CUIT/DNI"
                }
                if (this.campos.domicilio.trim() == "") {
                    respuesta = "Completar el Domicilio Fiscal"
                }
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(this.campos.email)) {
                    respuesta = "El Email no es válido"
                }
                if (this.campos.quiere_adicionales) {
                    if (this.campos.adicionales == "") {
                        respuesta = "Indicar la cantidad de " + this.campos.adicionales_tipo
                    }
                    if (this.campos.adicionales > 15) {
                        respuesta = "La cantidad máxima permitida de " + this.campos.adicionales_tipo + " es de 15"
                    }
                    if (this.campos.adicionales <= 0 ) {
                        respuesta = "La cantidad mínima permitida de " + this.campos.adicionales_tipo + " es de 1"
                    }

                }
                return respuesta;
            },

            informar_error(txt) {
                // this.resultado = txt;
                // this.resultado_modo = 'error';
                alertify.alert(txt);
                this.habilitado = true;
            },

            resetear_resultado() {
                this.resultado = null;
                this.resultado_modo = null;
            },

            home() {
                this.resetear_resultado();
                this.cambiar_modo('formulario');
            },

            rango_cantidad(event) {
                var value = Number(event.target.value)

                if (value > 50) {
                    this.campos.cantidad = 50;
                } else if (value <= 0 || Number.isNaN(value)) {
                    this.campos.cantidad = 1;
                } else {
                    this.campos.cantidad = value;
                }
            },

            test_referer() {
                // para testear el envio a admin-ajax.php
                var data = {
                    action: 'test_referer',
                    datos: self.campos,
                    // _ajax_nonce: jQuery('#solicitud_email_ajax_nonce').data('nonce')
                };

                jQuery.ajax({
                    type: 'POST',
                    url: `${server()}/wp-admin/admin-ajax.php`,
                    data: data,
                    contentType: 'application/x-www-form-urlencoded',
                    // dataType: 'json',
                    success: function (msg) {
                        log(msg);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        log(jqXHR, errorThrown);
                    },
                    complete: function () {
                        log("complete")
                    }
                });

            },


        },

        mounted() {

            alertify.defaults.transition = 'fade';
            alertify.defaults.glossary.title = "Revisa los siguientes datos"
            alertify.defaults.glossary.ok = "Aceptar";

            this.cargar_distribuidores();

            if (this.parametros.debug) {
                this.campos = {
                    grupo: 'distribuidores',
                    tipo: this.parametros.tipo_licenciamiento,
                    titulo: null,
                    sistema: this.parametros.sistema,
                    rubro: this.parametros.rubro,
                    idsistema: this.parametros.idsistema,
                    pack: this.parametros.pack,
                    cantidad: 1,
                    quiere_adicionales: false,
                    adicionales: "",
                    nombre: 'Esteban',
                    apellido: 'Lombardi',
                    email: 'esteban@lombardinet.com',
                    telefono: '011 4444-1111',
                    dni: "99888777",
                    cargo: "Programador",
                    razon_social: 'Mi Empresa S.A.',
                    tipo_documento: 'cuit',
                    cuit: '27220923598', //'30-51542474-8', //
                    domicilio: 'Domicilio',
                    iibb: '11-2223445-0',
                    distribuidor: {
                        distribuidor: '',
                        email: ''
                    },
                    es_cliente: false,
                    forma_pago: "Débito automático Tarjeta de Crédito",
                    forma_pago_cod: 'AUT',
                    tarjeta: {
                        titular: 'Mi nombre',
                        tarjeta: 'Visa',
                        numero: '4509111111111111',
                        vto_mes: new Date().getMonth() + 1,
                        vto_anio: new Date().getFullYear()
                    },
                    versiones_instaladas: null,
                    codcli: '29', 
                    tiene_sar: false
                }
            }


            if (this.parametros.tipo_licenciamiento == 'software') {
                this.acepta_label = 'Acepto los Términos y Condiciones Convenio de Licencia de Uso de Software.'
                this.campos.titulo = "SOLICITUD DE LICENCIA TEMPORAL DE SOFTWARE";
                this.campos.adicionales_tipo = "Accesos Adicionales"
            }
            if (this.parametros.tipo_licenciamiento == 'saas') {
                this.acepta_label = 'Acepto los Términos y Condiciones de Easy Soft SAAS y del Convenio de Licencia de Uso de Software.'
                this.campos.titulo = "SOLICITUD DE SERVICIO EASY SOFT SAAS";
                this.campos.adicionales_tipo = "Usuarios Adicionales"
            }

        },
    }
</script>


<style lang="scss">
    @import "@/assets/scss/form.scss";
</style>
